<script setup lang="ts">
import type { Tutorial } from '@/types';
import InfoSectionTutorialTile from './InfoSectionTutorialTile.vue';

type Props = {
  tutorialTiles: Tutorial[];
}

const props = defineProps<Props>();
</script>

<template>
  <div class="info-section-tutorial">
    <h2 class="info-section-tutorial__title font-weight-medium">
      {{ $t('thanks.infoSection.howToMake') }}
    </h2>
    <div class="info-section-tutorial__tiles">
      <InfoSectionTutorialTile
        v-for="(tutorial, index) in props.tutorialTiles"
        :key="index"
        :title="tutorial.title"
        :text="tutorial.text"
        :link="tutorial.link"
        :icon="tutorial.icon"
      />
    </div>
  </div>
</template>

<style lang="scss">
@use '@/assets/css/variables.scss' as variables;

.info-section-tutorial {
  background-color: #EDEDED;
  padding: 32px;

  @media (min-width: map-get(variables.$grid-breakpoints, 'md')) {
    background-color: #fff;
  }

  &__title {
    text-align: center;
    color: #ED1C24;
    margin-bottom: 32px;
  }
  &__tiles {
    display: grid;
    grid-template-columns: 1fr;
    gap: 32px;

    @media (min-width: map-get(variables.$grid-breakpoints, 'md')) {
      grid-template-columns: repeat(2, 1fr);
    }
  }
}
</style>
